<button class="audio-button"
        [ngClass]="{ 'audio-button-stopped': !playing, 'audio-button-playing': playing }"
        [disabled]="!loaded"
        (mousedown)="onMouseDown()"
        (touchstart)="onTouchStart()">
  {{caption}}
</button>
